import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rr-skipper',
  standalone: false,
  templateUrl: './skipper.component.html',
  styleUrl: './skipper.component.scss'
})
export class SkipperComponent {
  @Input() upActive: boolean = true;
  @Input() downActive: boolean = true;

  @Output() upClick: EventEmitter<any> = new EventEmitter();
  @Output() downClick: EventEmitter<any> = new EventEmitter();
}
